import React from 'react';

const ClockIcon = ({ size = 10, color = 'currentColor', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1449_5978)">
      <path
        d="M4.99982 0C2.24312 0 0 2.24294 0 5C0 7.75706 2.24312 10 4.99982 10C7.75706 10 9.99982 7.75706 9.99982 5C9.99982 2.24294 7.75706 0 4.99982 0ZM4.99982 9.33337C2.61048 9.33337 0.666631 7.38952 0.666631 5C0.666631 2.61048 2.61066 0.666631 4.99982 0.666631C7.38952 0.666631 9.33319 2.61048 9.33319 5C9.33319 7.38952 7.3897 9.33337 4.99982 9.33337Z"
        fill={color}
      />
      <path
        d="M7.47615 4.638H5.33326V1.8046C5.33326 1.62047 5.18399 1.47119 5.00004 1.47119C4.81627 1.47119 4.66699 1.62065 4.66699 1.8046V5.30445H7.47615C7.66009 5.30445 7.80937 5.15536 7.80919 4.97123C7.80919 4.78728 7.65974 4.638 7.47615 4.638Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_1449_5978">
        <rect width="10" height="10" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ClockIcon;
